import React from 'react';
import styles from './styles';
import ToolbarButton from './ToolbarButton';
import {DataTableContext} from '../Utils/DataTableContext';


const TopToolbar = props => {
  const {handleFetchParamChange} = React.useContext(DataTableContext);

  const paramKeys = Object.keys(props.activity ? props.paramOptions : props.settings.paramOptions);

  // const buttonWidth = 100 / paramKeys.length + '%';
  const buttonWidth = props.tableElement && props.tableElement.current
    ? Math.floor(props.tableElement.current.clientWidth / paramKeys.length + 5) + 'px'
    : Math.floor(100 / paramKeys.length) + '%' ;
  // console.log(props.tableElement.current ? props.tableElement.current.clientWidth / paramKeys.length + 5 + 'px' : '100%')
  const firstButtonWidth = parseInt(buttonWidth) - 5 + 'px';

  return(
   <div style={styles.container}>
     {paramKeys.map((key, i) => {
       const displayText = props.activity ? props.paramOptions[key] : props.settings.paramOptions[key]
       return(
         <ToolbarButton
           key={key}
           changeParam={props.handleAction ? props.handleAction : handleFetchParamChange }
           text={displayText}
           value={key}
           width={i === 0 ? firstButtonWidth : buttonWidth}
           active={props.activeUserParam ? props.activeUserParam.replace(/%20/g, ' ') === (props.activity ? props.paramOptions[key] : props.settings.paramOptions[key]) : false}
           last={i === paramKeys.length - 1}
           first={i === 0}
           zIndex={paramKeys.length - i}
           zMax={paramKeys.length + 1}
         />
       )
     })
     }
   </div>
  );
}


export default TopToolbar;
